import { StepName } from '|/app/services';

const VERIFICATION_STEP_LABELS: Partial<Record<StepName, string>> = {
  [StepName.IdentityVerification]: 'Identity verification',
  [StepName.Income]: 'Income verification',
  [StepName.Address]: 'Address verification',
  [StepName.TradeVerification]: 'Trade verification',
  [StepName.AdditionalIncome]: 'Additional income verification',
  [StepName.SelfieVerification]: 'Selfie verification'
};

export const getVerificationStepLabel = (stepId: StepName, fallback: string): string =>
  VERIFICATION_STEP_LABELS[stepId] ?? fallback;
